import round from "lodash/round";
import { TIME_ESTIMATION } from "../constants/timeEstimation";
import type { SetsAndItemsType } from "../types/tag";
import { tagIds } from "./learningModes";

export const estimateReadingTime = ({
	numStimuli,
	numQuestionsPerStimulus,
}: {
	numStimuli: number;
	numQuestionsPerStimulus: number;
}) => {
	return round(
		numStimuli * TIME_ESTIMATION.BASE_READING_TIME +
			numQuestionsPerStimulus * TIME_ESTIMATION.READING.TIME_PER_QUESTION,
	);
};

export const estimateListeningTime = ({
	numStimuli,
	averageAudioLength,
	totalQuestions,
}: {
	numStimuli: number;
	averageAudioLength: number;
	totalQuestions: number;
}) => {
	return round(
		numStimuli * averageAudioLength +
			totalQuestions * TIME_ESTIMATION.LISTENING.AVERAGE_ANSWER_TIME,
	);
};

export const estimateSpeakingTime = ({
	numStimuli,
}: {
	numStimuli: number;
}) => {
	return round(numStimuli * TIME_ESTIMATION.SPEAKING.AVERAGE_TIME_PER_STIMULUS);
};

export const estimateWritingTime = ({
	numStimulus,
}: {
	numStimulus: number;
}) => {
	return round(
		numStimulus * TIME_ESTIMATION.WRITING.ACADEMIC_DISCUSSION_TIME +
			numStimulus * TIME_ESTIMATION.WRITING.INTEGRATED_WRITING_TIME,
	);
};

export const estimateSessionTimeForTagId = (
	tagId: number,
	setsAndItems: SetsAndItemsType,
) => {
	switch (tagId) {
		case tagIds.reading:
			return estimateReadingTime({
				numStimuli: setsAndItems[tagIds.reading].forEstimateSets,
				numQuestionsPerStimulus: setsAndItems[tagIds.reading].forEstimateItems,
			});
		case tagIds.listening:
			return estimateListeningTime({
				numStimuli: setsAndItems[tagIds.listening].forEstimateSets,
				totalQuestions: setsAndItems[tagIds.listening].forEstimateItems,
				averageAudioLength: 4,
			});
		case tagIds.speaking:
			return estimateSpeakingTime({
				numStimuli: setsAndItems[tagIds.speaking].forEstimateSets,
			});
		case tagIds.writing:
			return estimateWritingTime({
				numStimulus: setsAndItems[tagIds.writing].forEstimateSets,
			});
		default:
			return 10;
	}
};

export const estimateSessionTime = ({
	tagIds,
	setsAndItems,
}: {
	tagIds: number[];
	setsAndItems: SetsAndItemsType;
}) => {
	return tagIds.reduce((acc, tagId) => {
		return acc + estimateSessionTimeForTagId(tagId, setsAndItems);
	}, 0);
};
